import React from 'react';
import { Box, Typography } from '@mui/material';
import GitHubCalendar from 'react-github-calendar';

export const Github = (): React.ReactNode => {
  return (
    <Box sx={{ mb: 6 }}>
      <Typography
        variant='h3'
        sx={{
          textAlign: 'center',
          mb: 4,
          fontSize: { xs: '1.5rem', md: '2rem' },
          fontWeight: 'bold',
        }}
      >
        Days I{' '}
        <Box
          component='span'
          sx={{
            color: 'primary.main',
            fontWeight: 'bold',
          }}
        >
          Code
        </Box>
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          p: 3,
          borderRadius: 2,
          background: 'rgba(138, 73, 168, 0.05)',
          border: '1px solid rgba(138, 73, 168, 0.1)',
        }}
      >
        <GitHubCalendar
          username='islommashanlo'
          blockSize={15}
          blockMargin={5}
          fontSize={16}
        />
      </Box>
    </Box>
  );
};
